import { connect } from 'react-redux';
import {
  localizationSelectors,
  servicesSelectors
} from '@lifesize/nucleus';
import { login } from 'actions/Auth';
import AuthView from 'components/Auth/Auth';
import { selectIsLoggedIn } from 'selectors/auth';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const loginLanguage = _get(localizationSelectors.localization(state), 'language');
  const canConnect = servicesSelectors.selectCanConnect(state);
  const willRetry = servicesSelectors.selectWillRetry(state);

  return {
    authFailure: _get(state, 'app.jwt.authFailure'),
    endRoute: _get(state, 'app.jwt.lastRoute'),
    guestName: _get(state, 'app.jwt.guestName'),
    ipAddressOverride: _get(state, 'nucleus.cluster.ipAddressOverride'),
    isLoggedIn: selectIsLoggedIn(state),
    loginLanguage,
    reload: canConnect && !willRetry,
    shouldLogin: canConnect
  };
};

function mapDispatchToProps(dispatch) {
  return {
    registeredLogin: () => (dispatch(login())), // not CNUC's authActions.login
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthView);
